import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AuthService } from '../service/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.authService.checkAuthStatus().pipe(
      tap(isAuthenticated => {
        if (!isAuthenticated) {
          console.log('🚫 [AUTH] Access denied, redirecting to login');
          this.authService.login();
        }
      }),
      map(isAuthenticated => isAuthenticated)
    );
  }
}

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  return authService.checkAuthStatus().pipe(
    tap(isAuthenticated => {
      if (!isAuthenticated) {
        authService.login();
      }
    }),
    map(isAuthenticated => isAuthenticated),
  );
};
